import Description from "@/partials/elements/Description";
import Headline from "@/partials/elements/Headline";
import React from "react";

export default function TeamMemberCardDetails({ member }) {
  return (
    <div className="md:text-left  my-4">
      <Headline
        text={member?.name}
        extraClass={"text-xs md:text-lg line-clamp-1"}
      />
      <Description
        text={member?.designation}
        extraClass={"md:text-base text-xs"}
      />
    </div>
  );
}
